/* eslint-disable */
// Based on https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal

class ModalDialog {
    constructor() {
        this.instances = document.querySelectorAll('[data-progressive-enhancement="off"][data-progressive-enhancement-type="modal-dialog"]');

        this.modalDialogsStatus = null;
    }

    init(helpers) {
        const self = this;

        self.helpers = helpers;

        self.createModalDialogsDiv(self);

        self.enhanceAll(self);

        self.modalDialogsStatus = 'closed';

        document.documentElement.dataset.modalDialogsStatus = self.modalDialogsStatus;
    }

    closeModalDialog(e, self) {
        let body = document.querySelector('body'),
            modalDialog,
            scrollY,
            triggerButton;

        if ('click' !== e.type) {
            return;
        }
        
        if (!e.currentTarget.classList.contains('js-modal-dialog__close-button')) {
            return;
        }

        modalDialog = e.currentTarget.parentElement;

        triggerButton = document.querySelector('#' + e.currentTarget.dataset.modalDialogTriggerId);

        for (let child of body.children) {
            if (self.modalDialogsDiv === child) {
                continue;
            }

            self.helpers.accessibleShow(child);
            child.style.removeProperty('--display');
            
            if ('' === child.getAttribute('style')) {
                child.removeAttribute('style');
            }
        }

        self.helpers.accessibleHide(self.modalDialogsDiv);

        modalDialog.hidden = true;

        triggerButton.focus();

        self.modalDialogsStatus = 'closed';

        document.documentElement.dataset.modalDialogsStatus = self.modalDialogsStatus;

        scrollY = body.style.getPropertyValue('--scrollY').slice(0, -2);

        window.scrollTo(0, parseInt(scrollY || '0'));

        body.style.removeProperty('--scrollY');
    }

    createModalDialogsDiv(self) {
        let body = document.querySelector('body'),
            modalDialogsDiv = document.createElement('div');

        modalDialogsDiv.classList.add('modal-dialogs');

        modalDialogsDiv.classList.add('js-modal-dialogs');

        modalDialogsDiv.hidden = true;

        modalDialogsDiv.style.setProperty('--modalDialogsFadeInDuration', '200ms');
        modalDialogsDiv.style.setProperty('--modalDialogsFadeOutDuration', '500ms');

        body.insertBefore(modalDialogsDiv, body.childNodes[0]);

        modalDialogsDiv.addEventListener('click', e => {
            if (e.currentTarget !== e.target) {
                return;
            }

            let openModalDialog = modalDialogsDiv.querySelector('.js-modal-dialog[data-modal-dialog-status="open"] > .js-modal-dialog__close-button');

            if (!openModalDialog) {
                return;
            }

            openModalDialog.querySelector('.js-modal-dialog__close-button').click();
        });

        self.modalDialogsDiv = modalDialogsDiv;
    }

    enhance(instance, self) {
        if ('on' === instance.dataset.progressiveEnhancement) {
            return;
        }

        let closeButton,
            closeButtonSpan,
            heading,
            headingChildNodes,
            headingClone,
            headingText,
            span = document.createElement('span'),
            span2 = document.createElement('span'),
            triggerButton,
            modalDialog = document.createElement('div');

        heading = instance.querySelector('#' + instance.getAttribute('aria-labelledby'));

        if (
            instance.dataset.progressiveEnhancementMediaQuery
            && '' !== instance.dataset.progressiveEnhancementMediaQuery
            && !instance.dataset.progressiveEnhancementReversion
        ) {
            let reversion = instance.cloneNode(true);

            self.reversionsDiv.appendChild(reversion);

            instance.dataset.progressiveEnhancementReversion = reversion.id;

            if(!window.matchMedia(instance.dataset.progressiveEnhancementMediaQuery).matches) {
                return;
            }
        }

        if ('H2' !== heading.tagName) {
            let originalHeadingLevel = heading.tagName.substring(1);

            modalDialog.dataset.originalHeadingLevel = originalHeadingLevel;

            instance = self.helpers.changeHeadingLevels(instance, originalHeadingLevel, 2);

            heading = instance.querySelector('#' + instance.getAttribute('aria-labelledby'));
        }

        headingText = heading.textContent;

        headingClone = heading.cloneNode(true);

        headingChildNodes = headingClone.childNodes;

        modalDialog.id = 'modal-dialog--' + self.helpers.sanitizeTitle(headingText);

        heading.id = modalDialog.id + '__heading';

        modalDialog.setAttribute('aria-labelledby', heading.id);

        modalDialog.classList.add('modal-dialog');

        modalDialog.classList.add('js-modal-dialog');

        modalDialog.setAttribute('role', 'dialog');

        modalDialog.setAttribute('aria-modal', 'true');

        modalDialog.hidden = true;

        triggerButton = self.helpers.createButton('', {
            "id": 'modal-dialog-trigger--' + modalDialog.id,
            "class": 'modal-dialog-trigger-button js-modal-dialog-trigger-button',
            "aria-controls": modalDialog.id,
            "data-progressive-enhancement": "on",
            "data-progressive-enhancement-type": instance.dataset.progressiveEnhancementType,
        });

        if (instance.dataset.progressiveEnhancementMediaQuery) {
            triggerButton.dataset.progressiveEnhancementMediaQuery = instance.dataset.progressiveEnhancementMediaQuery;

            triggerButton.dataset.progressiveEnhancementReversion = instance.dataset.progressiveEnhancementReversion;

            document.querySelector('#progressive-enhancement-reversions #' + triggerButton.dataset.progressiveEnhancementReversion).dataset.progressiveEnhancementReversion = triggerButton.id;
        }

        closeButton = self.helpers.createButton('', {
            'class': 'modal-dialog__close-button js-modal-dialog__close-button',
            'aria-label': i18n.ModalDialog.closeDialog,
            'aria-describedby': heading.id,
            'data-modal-dialog-trigger-id': triggerButton.id,
        });

        closeButtonSpan = document.createElement('span');

        closeButtonSpan.appendChild(document.createTextNode(i18n.ModalDialog.close));

        closeButton.appendChild(closeButtonSpan);

        modalDialog.appendChild(heading.parentElement.removeChild(heading));

        modalDialog.appendChild(closeButton);

        while (instance.childNodes[0]) {
            modalDialog.appendChild(instance.removeChild(instance.childNodes[0]));
        }

        while (headingChildNodes[0]) {
            span.appendChild(headingClone.removeChild(headingChildNodes[0]));
        }

        span.appendChild(span2);

        span2.className = 'visually-hidden';

        span2.appendChild(document.createTextNode(' (' + i18n.ModalDialog.modalDialog + ')'));

        triggerButton.appendChild(span);

        self.modalDialogsDiv.appendChild(modalDialog);

        triggerButton.addEventListener('click', (e) => {
            self.openModalDialog(e, self);
        });

        closeButton.addEventListener('click', (e) => {
            self.closeModalDialog(e, self);
        });

        instance = instance.parentElement.replaceChild(triggerButton, instance);
    }

    enhanceAll(self) {
        if ('on' !== self.modalDialogsStatus) {
            for (let instance of self.instances) {
                instance = self.enhance(instance, self);
            }

            window.addEventListener('keyup', e => {
                if ('Escape' !== e.key) {
                    return;
                }
    
                if ('open' !== document.documentElement.dataset.modalDialogsStatus) {
                    return;
                }
    
                if (!document.documentElement.dataset.openModalDialog) {
                    return;
                }
                
                e.stopImmediatePropagation();
                
                let openModalDialog = document.querySelector('#' + document.documentElement.dataset.openModalDialog),
                    closeButton = openModalDialog.querySelector('.js-modal-dialog__close-button'),
                    triggerButton = document.querySelector('#' + closeButton.getAttribute('data-modal-dialog-trigger-id'));
    
                closeButton.click();
    
                document.querySelector('#' + document.documentElement.dataset.openModalDialog).hidden = true;
    
                document.documentElement.removeAttribute('data-open-modal-dialog');

                triggerButton.focus();
            });

            self.modalDialogsStatus = 'on';

            if (self.modalDialogsStatus) {
                if (document.documentElement.dataset.progressiveEnhancements) {
                    document.documentElement.dataset.progressiveEnhancements += ' modal-dialog';
                } else {
                    document.documentElement.dataset.progressiveEnhancements = 'modal-dialog';
                }
            }
        }

        document.documentElement.dataset.modalDialogsStatus = self.tabbedInterfacesStatus;
    }

    openModalDialog(e, self) {
        let body = document.querySelector('body'),
            closeButton,
            modalDialog;

        if ('click' !== e.type) {
            return;
        }

        if (!e.currentTarget.hasAttribute('aria-controls')) {
            return;
        }

        if (!self.modalDialogsDiv.querySelector('#' + e.currentTarget.getAttribute('aria-controls'))) {
            return;
        }

        modalDialog = self.modalDialogsDiv.querySelector('#' + e.currentTarget.getAttribute('aria-controls'));

        closeButton = modalDialog.querySelector('.js-modal-dialog__close-button');

        body.style.setProperty('--scrollY', window.scrollY + 'px');

        for (let child of body.children) {
            if (self.modalDialogsDiv === child) {
                continue;
            }

            self.helpers.accessibleHide(child);
        }

        modalDialog.hidden = false;

        self.helpers.accessibleShow(self.modalDialogsDiv);

        document.documentElement.dataset.openModalDialog = modalDialog.id;

        self.modalDialogsStatus = 'open';

        document.documentElement.dataset.modalDialogsStatus = self.modalDialogsStatus;

        if (self.modalDialogsDiv.style.getPropertyValue('--modalDialogsFadeInDuration')) {
            let duration = self.modalDialogsDiv.style.getPropertyValue('--modalDialogsFadeInDuration').slice(0, -2);
            
            setTimeout(function() {
                closeButton.focus();
            }, duration, closeButton);
        } else {
            closeButton.focus();
        }
    }
}// end Class

// Singleton
export default ModalDialog;